import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./FAQ.css";

import I18nText from "../components/I18nText";
import { track } from "../lib/analytics";

function FaqItem({ item }) {
    const paragraphs = item.paragraphs || [];
    return (
        <div className="faq-item" data-testid={`faq-item-${item.num}`}>
            <div>
                <div className="faq-num mono">{item.num}</div>
                <div className="faq-q">
                    <I18nText
                        i18nKey={`faq.categories.${item._cat}.items.${item._idx}.q`}
                    />
                </div>
            </div>
            <div className="faq-a">
                <span className="short-answer">
                    <I18nText
                        i18nKey={`faq.categories.${item._cat}.items.${item._idx}.short`}
                    />
                </span>
                {paragraphs.map((_p, pi) => (
                    <p key={pi}>
                        <I18nText
                            i18nKey={`faq.categories.${item._cat}.items.${item._idx}.paragraphs.${pi}`}
                        />
                    </p>
                ))}
            </div>
        </div>
    );
}

export default function FAQ() {
    const { t } = useTranslation();
    const categories = t("faq.categories", { returnObjects: true }) || [];

    useEffect(() => {
        track("faq_view", {});
        document.title = t("faq.title");
    }, [t]);

    const onMailto = () => track("legal_contact_click", { page: "faq" });

    return (
        <div data-testid="faq-page">
            <section className="faq-hero" data-testid="faq-hero">
                <div className="section-label mono">{t("faq.sectionLabel")}</div>
                <h1><I18nText i18nKey="faq.h1" /></h1>
                <p className="faq-hero-lede">{t("faq.lede")}</p>
            </section>

            {categories.map((cat, ci) => (
                <section
                    className="faq-category"
                    key={ci}
                    data-testid={`faq-category-${ci}`}
                >
                    <h2>
                        <I18nText i18nKey={`faq.categories.${ci}.h2`} />
                    </h2>
                    {(cat.items || []).map((item, ii) => (
                        <FaqItem
                            key={item.num}
                            item={{ ...item, _cat: ci, _idx: ii }}
                        />
                    ))}
                </section>
            ))}

            <section className="faq-closing" data-testid="faq-closing">
                <div className="faq-closing-inner">
                    <div className="section-label mono">{t("faq.closingLabel")}</div>
                    <h2><I18nText i18nKey="faq.closingH2" /></h2>
                    <p className="faq-closing-sub">{t("faq.closingSub")}</p>
                    <a
                        href={`mailto:${t("faq.closingEmail")}`}
                        className="faq-closing-email"
                        data-testid="faq-closing-email"
                        onClick={onMailto}
                    >
                        {t("faq.closingEmail")}
                    </a>
                </div>
            </section>
        </div>
    );
}
